import { Box, Divider, Typography } from '@mui/material'

import { color } from 'config/color'
import { FormLabel } from 'components'
import { useMobileBreakpoints } from 'utils'

interface ILinkedAccountCard {
  accountId: string
  serviceAddress: string
}

export const LinkedAccountCard = ({
  accountId,
  serviceAddress
}: ILinkedAccountCard): JSX.Element => {
  const isMobile = useMobileBreakpoints()

  return (
    <Box border={`1px solid ${color.secondary.dark[300]}`}>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        p={1}
        bgcolor={color.grey[100]}
        gap={isMobile ? 1 : 0}
      >
        <Box display="flex" flexDirection="row" alignItems="center">
          <FormLabel marginBottom={0}>Account ID: </FormLabel>
          <Typography color={color.grey[600]} fontWeight={400} fontSize={15}>
            {accountId}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ color: color.secondary.dark[300] }} />

      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection={isMobile ? 'column' : 'row'}
        px={2}
        py={3}
        bgcolor={color.white}
        gap={isMobile ? 1 : 0}
      >
        <Box>
          <FormLabel>Service Address: </FormLabel>
          <Typography color={color.grey[900]} fontWeight={400} fontSize={15}>
            {serviceAddress}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
